import { IStore } from 'redux/IStore';
import { IOrder } from 'models/orders/order';
import { IOrderCardData, IOrderCardAction } from 'models/orders/ordercard';

/** Action Types */
export const GET_REQUEST: string = 'ordercard/GET_REQUEST';
export const GET_SUCCESS: string = 'ordercard/GET_SUCCESS';
export const GET_FAILURE: string = 'ordercard/GET_FAILURE';
export const CLEAR_DATA: string = 'ordercard/CLEAR_DATA';

/** Initial State */
const initialState: IOrderCardData = {
	order: null,
	isFetching: false,
};

/** Reducer */
export function orderCardReducer(state = initialState, action: IOrderCardAction) {
	switch (action.type) {
		case GET_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				order: action.payload.order,
				isFetching: false,
			});

		case GET_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case CLEAR_DATA:
			return Object.assign({}, state, {
				order: null,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getOrder(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(orderCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/' + id,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOrder) => {
						dispatch(getOrderCardSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(orderCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(orderCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(orderCardFailure(err));
			});
	};
}

/** Action Creator */
export function orderCardRequest(): IOrderCardAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function getOrderCardSuccess(order: IOrder): IOrderCardAction {
	return {
		type: GET_SUCCESS,
		payload: {
			order,
		},
	};
}

/** Action Creator */
export function orderCardFailure(message: any): IOrderCardAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function clearData(): IOrderCardAction {
	return {
		type: CLEAR_DATA,
	};
}
